/* eslint-disable */
import * as Yup from 'yup';
import moment from 'moment';
import kycFormModel from './kycFormModel';
const {
  formField: {
    firstName,
    lastName,
    email,
    contanct_no,
    passport_id,
    passport_id_file,
    work_profile,
    company_name,
    billing_company_name,
    address1,
    address2,
    city,
    state,
    zipcode,
    country,
    telephone,
    fax,
    invoice_email,
    website,
    comp_reg_no,
    nature_of_business,
    business_est_date,
    name_of_partner,
    contact_of_partner,
    shipping_address1,
    shipping_address2,
    shipping_city,
    shipping_state,
    shipping_zipcode,
    shipping_country,
    shipping_telephone,
    shipping_email,
    tax_id,
    port_of_discharge,
    comp_reg_no_file
  }
} = kycFormModel;

const visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
const phoneRegExp = /^[\+\d]?(?:[\d-.\s()]*)$/
const alphabatic = /^[aA-zZ\s]+$/
const pandcard =/^[A-Z0-9]*$/

export default function validationSchemaEdit(userinfo){
  const vatRegexMap = {
    AT: /^ATU\d{8}$/,                         // Austria
    BE: /^BE0?\d{9}$/,                        // Belgium
    BG: /^BG\d{9,10}$/,                       // Bulgaria
    HR: /^HR\d{11}$/,                         // Croatia
    CY: /^CY\d{8}[A-Z]$/,                     // Cyprus
    CZ: /^CZ\d{8,10}$/,                       // Czech Republic
    DK: /^DK\d{8}$/,                          // Denmark
    EE: /^EE\d{9}$/,                          // Estonia
    FI: /^FI\d{8}$/,                          // Finland
    FR: /^FR[A-HJ-NP-Z0-9]{2}\d{9}$/,         // France
    DE: /^DE\d{9}$/,                          // Germany
    EL: /^EL\d{9}$/,                          // Greece
    HU: /^HU\d{8}$/,                          // Hungary
    IE: /^IE\d{7}[A-W][A-IW]?$/,              // Ireland
    IT: /^IT\d{11}$/,                         // Italy
    LV: /^LV\d{11}$/,                         // Latvia
    LT: /^LT(\d{9}|\d{12})$/,                 // Lithuania
    LU: /^LU\d{8}$/,                          // Luxembourg
    MT: /^MT\d{8}$/,                          // Malta
    NL: /^NL\d{9}B\d{2}$/,                    // Netherlands
    PL: /^PL\d{10}$/,                         // Poland
    PT: /^PT\d{9}$/,                          // Portugal
    RO: /^RO\d{2,10}$/,                       // Romania
    SK: /^SK\d{10}$/,                         // Slovakia
    SI: /^SI\d{8}$/,                          // Slovenia
    ES: /^ES[A-Z0-9]\d{7}[A-Z0-9]$/,          // Spain
    SE: /^SE\d{10}01$/,                       // Sweden
  };
  
  function validateVATFormat(vatNumber) {
    const countryCode = vatNumber.slice(0, 2).toUpperCase();
    const regex = vatRegexMap[countryCode];
    if (!regex) return false;
    return regex.test(vatNumber);
  }
return [
  Yup.object().shape({
    [firstName.name]: Yup.string().required(`${firstName.requiredErrorMsg}`).matches(alphabatic, 'Only Alphabets should allow'),
    [lastName.name]: Yup.string().required(`${lastName.requiredErrorMsg}`).matches(alphabatic, 'Only Alphabets should allow'),
    [email.name]: Yup.string().email("Wrong email format") .min(3, "Minimum 3 symbols") .max(50, "Maximum 50 symbols") .required(`${email.requiredErrorMsg}`),
    [contanct_no.name]: Yup.string().matches(phoneRegExp, 'Contact number is not valid').min(10, "Please enter at least 10 characters").required(`${contanct_no.requiredErrorMsg}`),
    [work_profile.name]: Yup.string().required(`${work_profile.requiredErrorMsg}`).nullable(),
      }),
  Yup.object().shape({
    [comp_reg_no_file.name]: Yup.string().required(`${userinfo?.region === "India"?"GST Document (3 pager) is required":comp_reg_no_file.requiredErrorMsg}`),
    [company_name.name]: Yup.string().required(`${company_name.requiredErrorMsg}`),
    [billing_company_name.name]: Yup.string().required(`${billing_company_name.requiredErrorMsg}`),
    [address1.name]: Yup.string().required(`${address1.requiredErrorMsg}`),
    // [address2.name]: Yup.string().required(`${address2.requiredErrorMsg}`),
    [city.name]: Yup.string().required(`${city.requiredErrorMsg}`),
    [state.name]: (userinfo?.region === "Australia" || userinfo?.region === "India")?Yup.string().required(`${state.requiredErrorMsg}`).nullable():"",
    [zipcode.name]: (userinfo?.region === "Australia" || userinfo?.region === "India")?Yup.string().required(`${zipcode.requiredErrorMsg}`):"",
    [country.name]: Yup.string().required(`${country.requiredErrorMsg}`),
    [passport_id_file.name]: Yup.string().required(`${passport_id_file.requiredErrorMsg}`),
    [passport_id.name]: Yup.string().required(`${passport_id.requiredErrorMsg}`),
    [telephone.name]: Yup.string().matches(phoneRegExp, 'Contact number is not valid').min(10, "Please enter at least 10 characters").required(`${telephone.requiredErrorMsg}`),
    // [fax.name]: Yup.string().matches(phoneRegExp, 'Contact number is not valid').required(`${fax.requiredErrorMsg}`),
    [invoice_email.name]: Yup.string() .email("Wrong email format") .min(3, "Minimum 3 symbols") .max(50, "Maximum 50 symbols") .required(`${invoice_email.requiredErrorMsg}`),
    // [website.name]: Yup.string() .matches( /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/, 'Enter correct url!' ) .required(`${website.requiredErrorMsg}`),
    [comp_reg_no.name]: Yup.string().required(`${userinfo?.region === "India"?"PAN/GST Document is required":comp_reg_no.requiredErrorMsg}`),
    [tax_id.name]: userinfo?.region === "India"?Yup.string().required(`GST No is required`).min(15, "Enter Valid GST No").max(15, "Enter Valid GST No"):userinfo?.region === "Europe"?Yup.string().required(`VAT is required`).test("is-valid-vat", "Enter valid VAT number", (value) => {
      if (!value) return false;
      return validateVATFormat(value);
    }):"",
    [nature_of_business.name]: Yup.string().required(`${nature_of_business.requiredErrorMsg}`),
    [business_est_date.name]: Yup.string().required(`${business_est_date.requiredErrorMsg}`),
    [name_of_partner.name]: Yup.string().required(`${name_of_partner.requiredErrorMsg}`),
    [contact_of_partner.name]: Yup.string().matches(phoneRegExp, 'Contact number is not valid').min(10, "Please enter at least 10 characters").required(`${contact_of_partner.requiredErrorMsg}`),
  
    // [shipping_address1.name]: Yup.string().required(`${shipping_address1.requiredErrorMsg}`).nullable(),
    // [shipping_address2.name]: Yup.string().required(`${shipping_address2.requiredErrorMsg}`),
    // [shipping_city.name]: Yup.string().required(`${shipping_city.requiredErrorMsg}`),
    // [shipping_state.name]: Yup.string().required(`${shipping_state.requiredErrorMsg}`).nullable(),
    // [shipping_zipcode.name]: Yup.string()
    //   .required(`${shipping_zipcode.requiredErrorMsg}`),
    // [shipping_country.name]: Yup.string().required(`${shipping_country.requiredErrorMsg}`),
    // [shipping_telephone.name]: Yup.string().matches(phoneRegExp, 'Contact number is not valid').min(10, "Please enter at least 10 characters").required(`${shipping_telephone.requiredErrorMsg}`),
    // [shipping_email.name]: Yup.string() .email("Wrong email format") .min(3, "Minimum 3 symbols").max(50, "Maximum 50 symbols") .required(`${shipping_email.requiredErrorMsg}`),
    // [port_of_discharge.name]: Yup.string().required(`${port_of_discharge.requiredErrorMsg}`),
  }),
]
};
